import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { ConvexReactClient } from "convex/react";
import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n/config";
import "./index.css";
// Eager-load React Flow base styles so the lazy-loaded spec graph view
// renders correctly on first switch (lazy-chunk CSS produces a flash of
// zero-size canvas — see frontend-doctrine §12.4).
import "@xyflow/react/dist/style.css";
import { routeTree } from "./routeTree.gen";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConvexAuthProvider client={convex}>
      <RouterProvider router={router} />
    </ConvexAuthProvider>
  </React.StrictMode>,
);
